/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import { Modal, Typography, Box, Button } from "@mui/material"
import { useTheme } from "@mui/material"

const DeleteModal = ({open, handleClose, handleDelete, item}) => {
    const theme = useTheme();

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="delete-modal-title"
            aria-describedby="delete-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                color: theme.palette.text.color,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: theme.palette.secondary.main,
                borderRadius: 2,
                textAlign: 'left',
                boxShadow: 24,
                p: '12px',
                width: 350,
              }}
            >
              <Typography id="delete-modal-title" variant="h6" component="h2">
                Confirm Delete
              </Typography>
              <Typography id="delete-modal-description" sx={{ mt: 2 }}>
                {`Are you sure you want to delete this device?`}
              </Typography>
              <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
                <Button variant="outlined" onClick={handleClose} sx={{textTransform: 'none', color: theme.palette.text.color, border: `1px solid ${theme.palette.border.color}`}}>
                  Cancel
                </Button>
                <Button variant="contained" color="error" onClick={handleDelete} sx={{textTransform: 'none'}}>
                  Delete
                </Button>
              </Box>
            </Box>
          </Modal>
    )
}

export default DeleteModal